import TrainIcon from "@mui/icons-material/Train";
import MyLocationIcon from "@mui/icons-material/MyLocation";
import RailwayAlertIcon from "@mui/icons-material/RailwayAlert";
import { bplrtFlag, stellarFlag } from "./componentsFlag";
import { colorStyling } from "../helpers/color";
import { TrakoIcon } from "../icons";
import Role from "../helpers/roles";
import i18n from "i18next";
const tCommon = i18n.getFixedT(null, "common");

export const externalSidebarConfig = [
  ...(stellarFlag
    ? [
        {
          flag: "SMRT.TRAKO",
          path: "/analytics",
          icon: <TrakoIcon color={colorStyling.orange} />,
          label: tCommon("sidebar.StellarTrakoAnalytics"),
          condition: (_, userRole) => userRole !== Role.Eins,
        },
      ]
    : []),
  ...(bplrtFlag
    ? [
        {
          flag: "BPLRT.SMP",
          path: "/bplrt/smp",
          icon: (
            <MyLocationIcon
              fontSize="medium"
              sx={{
                color: colorStyling.orange,
              }}
            />
          ),
          label: tCommon("sidebar.BplrtSmp"),
          condition: (_, userRole) => userRole !== Role.Eins,
        },
        {
          flag: "SMRT_SRG",
          path: "/smrt/train-service-status",
          icon: (
            <TrainIcon
              fontSize="medium"
              sx={{
                color: "#F55858",
              }}
            />
          ),
          label: tCommon("sidebar.SmrtTrainStatus"),
          condition: (userPermission, userRole) =>
            userRole !== Role.Eins && userPermission?.smrtLine?.read,
        },
        {
          flag: "SMRT_TRAIN",
          path: "/smrt/train-disruption",
          icon: (
            <RailwayAlertIcon
              fontSize="medium"
              sx={{
                color: "#F55858",
              }}
            />
          ),
          label: tCommon("sidebar.SmrtDisruption"),
          condition: (_, userRole) => userRole !== Role.Eins,
        },
      ]
    : []),
];
